import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Alert, AlertDescription, AlertTitle } from '../components/ui/alert';
import { Badge } from '../components/ui/badge';
import { Construction, ArrowLeft, RefreshCw } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';

const DevelopmentPage = ({ title = 'صفحة قيد التطوير' }) => {
  const navigate = useNavigate();

  return (
    <Layout>
      <div className="container mx-auto p-4 md:p-6 flex flex-col items-center justify-center min-h-[80vh]" dir="rtl">
      <Card className="w-full max-w-md text-center p-6">
        <CardHeader className="pb-4">
          <div className="mx-auto mb-4 bg-amber-100 p-3 rounded-full w-fit">
            <Construction className="h-8 w-8 text-amber-600" />
          </div>
          <CardTitle className="text-xl">{title}</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <Alert className="border-amber-200 bg-amber-50">
            <Construction className="h-4 w-4 text-amber-600" />
            <AlertTitle className="text-amber-800">هذه الصفحة قيد التطوير</AlertTitle>
            <AlertDescription className="text-amber-700">
              نعمل بجد لإطلاق هذه الميزة قريبًا. شكرًا لصبركم.
            </AlertDescription>
          </Alert>

          <div className="flex flex-wrap justify-center gap-2">
            <Badge variant="secondary">قيد الإنشاء</Badge>
            <Badge variant="outline">قريبًا</Badge>
          </div>

          <div className="flex flex-col sm:flex-row gap-2 pt-4">
            <Button 
              variant="outline" 
              onClick={() => navigate(-1)}
              className="flex items-center gap-2"
            >
              <ArrowLeft className="h-4 w-4" />
              العودة
            </Button>
            <Button 
              onClick={() => window.location.reload()}
              className="flex items-center gap-2"
            >
              <RefreshCw className="h-4 w-4" />
              تحديث الصفحة
            </Button>
          </div>
        </CardContent>
      </Card>
      </div>
    </Layout>
  );
};

export default DevelopmentPage;
